import * as ActionsTypes from "../../../../common/constants/stateConstants";

/*---------------------------------------------GET-FACTURE-SOUSCRIPTION-------------------------------------------------*/
export const getFactureSouscriptionAction = (payload) => {
  return {
    type: ActionsTypes.GET_FACTURE_SOUSCRIPTION,
    payload,
  };
};

export const getFactureSouscriptionSuccessAction = (payload) => {
  return {
    type: ActionsTypes.GET_FACTURE_SOUSCRIPTION_SUCCESS,
    payload,
  };
};

export const getFactureSouscriptionFailAction = (payload) => {
  return {
    type: ActionsTypes.GET_FACTURE_SOUSCRIPTION_FAIL,
    payload,
  };
};

/*--------------------------------------------PAIEMENT-SOUSCRIPTION-------------------------------------------------*/
export const paiementSouscriptionAction = (payload) => {
  return {
    type: ActionsTypes.PAIEMENT_SOUSCRIPTION,
    payload,
  };
};

export const paiementSouscriptionSuccessAction = (payload) => {
  return {
    type: ActionsTypes.PAIEMENT_SOUSCRIPTION_SUCCESS,
    payload,
  };
};

export const paiementSouscriptionFailAction = (payload) => {
  return {
    type: ActionsTypes.PAIEMENT_SOUSCRIPTION_FAIL,
    payload,
  };
};

export const paiementSouscriptionReinitializationAction = (payload) => {
  return {
    type: ActionsTypes.PAIEMENT_SOUSCRIPTION_REINITIALIZATION,
    payload,
  };
};


export const tracePaymentInAccount = (payload, onSuccess) => ({
  type: ActionsTypes.TRACE_PAYMENT_IN_ACCOUNT,
  payload,
  onSuccess,
});

export const tracePaymentInAccountSuccess = (payload) => ({
  type: ActionsTypes.TRACE_PAYMENT_IN_ACCOUNT_SUCCESS,
  payload,
});

export const tracePaymentInAccountFail = (error) => ({
  type: ActionsTypes.TRACE_PAYMENT_IN_ACCOUNT_FAIL,
  payload: error,
});
